<div class="flex justify-end">
  <button
    (click)="reset()"
    [disabled]="!isFilter"
    style="
      background-color: #001b4d;
      color: white;
      padding: 7px 20px 7px 20px;
      border-radius: 5px;
    "
  >
    Reset
  </button>
  <button
    (click)="console()"
    [id]="productId"
    style="
      background-color: #78be20;
      color: white;
      padding: 7px 15px 7px 15px;
      border-radius: 5px;
      margin-left: 5px;
    "
  >
    <ion-icon name="funnel-outline" class="text-xs pr-1"></ion-icon>
    Filter
  </button>
  <!-- <ion-button (click)="console()" [id]="productId"  class="text-sm" [id]="productId">
  <ion-icon name="funnel-outline" class="text-xs pr-1"></ion-icon>Filters</ion-button> -->
</div>

<ion-modal
  color="light"
  #modal
  [trigger]="productId"
  (willPresent)="updateFormControlsState()"
  (willDismiss)="closeModal()"
>
  <ng-template>
    <ion-content (click)="checkActiveElementClass($event)" color="light">
      <ion-toolbar>
        <ion-title>Apply Filters</ion-title>
        <ion-buttons slot="end">
          <ion-button color="light" (click)="closeModal()"
            ><ion-icon name="close-circle-outline"></ion-icon
          ></ion-button>
        </ion-buttons>
      </ion-toolbar>

      <div class="w-[90%] my-4 mx-auto">
        <form [formGroup]="filterForm" class="space-y-6 md:space-y-4">
          <div class="flex">
            <div class="flex-grow mr-4 w-[50%]">
              <label
                for="first-name"
                class="block text-sm font-medium text-[#797979]"
                >All Lines</label
              >
              <div class="mt-1">
                <!-- <input type="text" formControlName="allLines" class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" /> -->
                <ng-select
                  formControlName="allLines"
                  class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  [searchable]="false"
                  [clearable]="false"
                >
                  <ng-option [value]="''" [disabled]="true">Select an option</ng-option>
                  <ng-option [value]="'all'">All</ng-option>
                  <ng-option [value]="'activeLine'">Active Lines</ng-option>
                  <ng-option [value]="'dcLine'">D/C Lines</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="flex-grow w-[50%]">
              <label
                for="first-name"
                class="block text-sm font-medium text-[#797979]"
                >Inserter Name</label
              >
              <div class="mt-1 relative">
                <input
                  (focus)="onFocusInserterName()"
                  type="text"
                  formControlName="inserterName"
                  class="active-element pr-6 block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
                <img
                  *ngIf="isSuggestionsLoading"
                  src="/assets/loaders/loading.gif"
                  class="active-element absolute h-4 w-4 z-10 right-2 bottom-3 top-[0.7rem]"
                />
                <div
                  *ngIf="
                    !isSuggestionsLoading &&
                    suggestions.length > 0 &&
                    showSuggestions
                  "
                  class="active-element absolute z-10 w-full bg-white border border-gray-300 rounded-lg shadow-md"
                >
                  <div
                    *ngFor="let suggestion of suggestions"
                    (click)="selectSuggestion(suggestion)"
                    class="cursor-pointer text-sm px-2 hover:bg-[#1967d2] hover:text-white hover:rounded"
                  >
                    {{ suggestion }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex">
            <!-- <div class="flex-grow mr-4">
              <label for="first-name" class="block text-sm font-medium text-[#797979]">Active Lines</label>
              <div class="mt-1">
                <select formControlName="activeLines" class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
                  <option value="" selected disabled>Select an option</option>
                  <option [value]="1">Yes</option>
                  <option [value]="0">No</option>
                </select>
              </div>
            </div> -->
            <div class="flex-grow">
              <label
                for="first-name"
                class="block text-sm font-medium text-[#797979]"
                >Product Type</label
              >
              <div class="mt-1">
                <ng-select
                  [ngClass]="{ 'greyed-out': product === 'endurance' }"
                  formControlName="productType"
                  class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  [searchable]="false"
                  [clearable]="false"
                >
                  <ng-option [value]="''" [disabled]="true">Select an option</ng-option>
                  <ng-option [value]="'all'">All</ng-option>
                  <ng-option *ngFor="let item of productsArr" [value]="item">{{ item }}</ng-option>
                </ng-select>
              </div>
            </div>
          </div>

          <div class="flex">
            <div class="flex-grow mr-4">
              <label
                for="start-date"
                class="block text-sm font-medium text-[#797979]"
                >Insertion Date Start</label
              >
              <div class="mt-1">
                <input
                  id="start-date"
                  type="date"
                  formControlName="insertionDateStart"
                  class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  (change)="updateEndDateMin()"
                />
              </div>
            </div>
            <div class="flex-grow">
              <label
                for="end-date"
                class="block text-sm font-medium text-[#797979]"
                >Insertion Date End</label
              >
              <div class="mt-1">
                <input
                  id="end-date"
                  type="date"
                  formControlName="insertionDateEnd"
                  class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
              </div>
            </div>
          </div>

          <div class="flex">
            <div class="flex-grow mr-4 w-[50%]">
              <label
                for="first-name"
                class="block text-sm font-medium text-[#797979]"
                >Skin Nick</label
              >
              <div class="mt-1">
                <div class="mt-1">
                  <ng-select
                    [ngClass]="{
                      'greyed-out':
                        product === 'arterial' ||
                        product === 'endurance' ||
                        product === 'cvc'
                    }"
                    formControlName="skinNick"
                    class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    [searchable]="false"
                    [clearable]="false"
                  >
                    <ng-option [value]="''" [disabled]="true">Select an option</ng-option>
                    <ng-option [value]="1">Yes</ng-option>
                    <ng-option [value]="0">No</ng-option>
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="flex-grow w-[50%]">
              <label
                for="first-name"
                class="block text-sm font-medium text-[#797979]"
                >Tip Position</label
              >
              <div class="mt-1">
                <input 
                [ngClass]="{'greyed-out': product !== 'dlx-rhythm'}"
                type="time" formControlName="tipPosition" class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" />
              </div>
            </div>
          </div>

          <div class="flex">
            <div class="flex-grow mr-4 w-[50%]">
              <label
                for="first-name"
                class="block text-sm font-medium text-[#797979]"
                >X-Ray</label
              >
              <div class="mt-1">
                <div class="mt-1">
                  <ng-select
                    [ngClass]="{
                      'greyed-out':
                        product === 'arterial' ||
                        product === 'endurance' ||
                        product === 'cvc' ||
                        product === 'midlines'
                    }"
                    formControlName="correlatedXray"
                    class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    [searchable]="false"
                    [clearable]="false"
                  >
                    <ng-option [value]="''" [disabled]="true">Select an option</ng-option>
                    <ng-option [value]="'all'">All</ng-option>
                    <ng-option [value]="'Lower 1/3 SVC/CAJ'">Lower 1/3 SVC/CAJ</ng-option>
                    <ng-option [value]="'Mid'">Mid</ng-option>
                    <ng-option [value]="'RA'">RA</ng-option>
                    <ng-option [value]="'Upper'">Upper</ng-option>
                    <ng-option [value]="'N/A'">N/A</ng-option>
                    <ng-option [value]="'Other'">Other</ng-option>
                  </ng-select>
                </div>
              </div>
            </div>
              <div class="flex-grow w-[50%]">
                <label
                  for="first-name"
                  class="block text-sm font-medium text-[#797979]"
                  >Did X-Ray Correlate</label
                >
                <div class="mt-1">
                  <div class="mt-1">
                    <ng-select
                    [ngClass]="{
                      'greyed-out':
                        product === 'arterial' ||
                        product === 'endurance' ||
                        product === 'cvc' ||
                        product === 'midlines'
                    }"
                      formControlName="did_x_ray_correlate"
                      class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      [searchable]="false"
                      [clearable]="false"
                    >
                      <ng-option [value]="''" [disabled]="true">Select an option</ng-option>
                      <ng-option [value]="'Yes'">Yes</ng-option>
                      <ng-option [value]="'No'">No</ng-option>
                      <ng-option [value]="'N/A'">N/A</ng-option>
                    </ng-select>
                  </div>
                </div>
              </div>
          </div>

          <div class="flex">
            <div class="flex-grow mr-4">
              <label
                for="start-date"
                class="block text-sm font-medium text-[#797979]"
                >Tourniquet Placed</label
              >
              <div class="mt-1">
                <input
                  id="start-date"
                  type="time"
                  formControlName="tourniquet_placed"
                  [ngClass]="{
                  'greyed-out':
                    product === 'arterial' ||
                    product === 'endurance' ||
                    product === 'cvc' ||
                    product === 'midlines'
                }"
                  class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
              </div>
            </div>
            <div class="flex-grow">
              <label
                for="end-date"
                class="block text-sm font-medium text-[#797979]"
                >Tourniquet Removed</label
              >
              <div class="mt-1">
                <input
                  id="end-date"
                  type="time"
                  formControlName="tourniquet_removed"
                  [ngClass]="{
                  'greyed-out':
                    product === 'arterial' ||
                    product === 'endurance' ||
                    product === 'cvc' ||
                    product === 'midlines'
                }"
                  class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
              </div>
            </div>
          </div>
          <div class="flex">
              <div class="flex-grow w-[50%] mr-6">
                <label
                  for="first-name"
                  class="block text-sm font-medium text-[#797979]"
                  >Successful Insertion</label
                >
                <div class="mt-1">
                  <div class="mt-1">
                    <ng-select
                      formControlName="successfulInsertion"
                      class="block w-[50%] h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      [searchable]="false"
                      [clearable]="false"
                    >
                      <ng-option [value]="''" [disabled]="true">Select an option</ng-option>
                      <ng-option [value]="1">Yes</ng-option>
                      <ng-option [value]="0">No</ng-option>
                    </ng-select>
                  </div>
                </div>
              </div>
          </div>
        </form>
        <div class="pt-8 md:pt-4 flex justify-between items-center space-x-2">
          <button
            (click)="closeModal()"
            class="w-full rounded-[5px] h-[40px] min-h-[40px] !bg-[#58585A] text-white flex items-center justify-center"
            style="line-height: 40px; padding: 0;"
          >
            Cancel
          </button>
          <ion-button
            [disabled]="!filterForm.valid"
            class="w-full"
            style="height: 40px; min-height: 40px; --padding-top: 0; --padding-bottom: 0;"
            expand="block"
            (click)="apply()"
            >Apply</ion-button
          >
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
